import React from "react";

function Dots({activeIndex, onclick, sliderImage}){
    return(
        <div className={styles.allDots} style={styles.allDots}>
            {sliderImage.map((slideImage, index) => (
                <span
                key={index}
                style={activeIndex === index ? styles.dot : styles.activeDot}
                onClick={() => onclick(index)}
                ></span>
            ))}
        </div>
    );
}

const styles = {
    allDots: {
        width: "100%",
        // height: "100%",
        position: "absolute",
        display: "flex",
        top: "85%",
        justifyContent: "center",
        zIndex: "200"
    },
    activeDot: {
        cursor: "pointer",
        height: "1rem",
        width: "1rem",
        margin: "0px 3px",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        borderRadius: "50%",
        display: "inline-block",
         backgroundColor: "rgba(255, 255, 255, 0.5)"
    },
    dot:{
        cursor: "pointer",
        height: "1rem",
        width: "1rem",
        margin: "0px 3px",
        backgroundColor: "black",
        borderRadius: "50%",
        display: "inline-block",
       
    }
}

export default Dots;